import * as React from 'react';
import * as _ from 'lodash';
import classNames from 'classnames';
import { ReactSortable } from 'react-sortablejs';
import GrabberIcon from '../../assets/images/grabber-16x16.svg';
import { __, setTableParams } from '../../core/utils';
import { updateTaskGroupOrder } from '../../redux/actions/table/substages';
import styles from '../../styles/flyouts/substages/TaskGroups.scss';

const TaskGroups = ({
  data,
  collapsed,
  readAction,
  is_project_administrator,
}) => {
  const orderedTaskGroups = _.sortBy(data.task_groups, ['order', 'id']);
  const reorderedTaskGroupIds = React.useRef([]);

  const handleReorder = (taskGroups) => {
    reorderedTaskGroupIds.current = _.map(taskGroups, 'id');

    setTableParams('stages', {
      substage_flyout: {
        ...data,
        task_groups: _.map(taskGroups, (taskGroup, index) => ({
          ...taskGroup,
          order: index + 1,
        })),
      },
    });
  };

  const persistReorder = () => {
    updateTaskGroupOrder(data.id, reorderedTaskGroupIds.current).then(() =>
      readAction(data.id)
    );
  };

  const getStatusLabel = (status) => {
    const statusLabels = {
      'not-started': __('stages.status.not-started'),
      started: __('stages.status.started'),
      finished: __('stages.status.finished'),
      closed: __('stages.status.closed'),
      reopened: __('stages.status.reopened'),
      canceled: __('stages.status.canceled'),
    };

    return _.get(statusLabels, status);
  };

  return (
    <div className={classNames(styles.wrapper, collapsed && styles.collapsed)}>
      <div className={classNames(styles.row, styles.header)}>
        <span className={styles.grabber} />
        <span className={styles.task}>{__('table.columns.task')}</span>
        <span className={styles.name}>{__('stage.substages.name')}</span>
        <span className={styles.status}>{__('stage.substages.status')}</span>
      </div>
      {!_.isEmpty(orderedTaskGroups) ? (
        <ReactSortable
          list={orderedTaskGroups}
          setList={handleReorder}
          animation={200}
          delayOnTouchStart={true}
          onEnd={persistReorder}
          disabled={!is_project_administrator}
        >
          {_.map(orderedTaskGroups, (taskGroup) => (
            <div key={taskGroup.id} className={styles.row}>
              <span className={styles.grabber}>
                {is_project_administrator && <GrabberIcon />}
              </span>
              <span className={styles.task}>{taskGroup.task_id}</span>
              <span className={styles.name}>{taskGroup.name}</span>
              <span className={styles.status}>
                {getStatusLabel(taskGroup.status)}
              </span>
            </div>
          ))}
        </ReactSortable>
      ) : (
        <div className={styles.emptyState}>{__('tasks.type.group')}</div>
      )}
    </div>
  );
};

export default TaskGroups;
